import Vue from 'vue'
import Router from 'vue-router'
import Weather from '@/components/Weather'
import Weatherr from '@/components/Weather/Weather'
import WeaPricter from '@/components/Weather/WeaPricter/WeaPricter'
import WeaPricterr from '@/components/Weather/WeaPricterr/WeaPricterr'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/Weather'
        },
        {
            path: '/Weather',
            name: 'Weather',
            component: Weather,
            meta: {
                showTop: true,
                showBottom: true
            },
        },
        {
            path: '/weatherr',
            component: Weatherr,
            meta: {
                showTop: false,
                showBottom: false
            },
            children: [
                {
                    path: '/weather/pricter',
                    component: WeaPricter
                },
                {
                    path: '/weather/pricterr',
                    component: WeaPricterr
                },
                {
                    path: '',
                    redirect: '/weather/pricter'
                },
            ]
        },
    ]
})
